import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'
import { Spacer } from 'components/Utility'

type Props = {
  dataCy?: string
  disabled?: boolean
  endIconPath?: string
  label: string
  onClick: () => void
  size: 'narrow' | 'xxxsmall' | 'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'short'
  startIconPath?: string
  type: 'light' | 'main' | 'dark' | 'outlined'
}

const BlueButton: FC<Props> = React.memo((props) => {
  const { dataCy = '', disabled, endIconPath, label, onClick, size, startIconPath, type } = props

  const sizeStyle = (() => {
    switch (size) {
      case 'narrow':
        return styles.button_narrow
      case 'xxxsmall':
        return styles.button_xxxsmall
      case 'xxsmall':
        return styles.button_xxsmall
      case 'xsmall':
        return styles.button_xsmall
      case 'small':
        return styles.button_small
      case 'medium':
        return styles.button_medium
      case 'large':
        return styles.button_large
      case 'short':
        return styles.button_short
      default:
        return styles.button_medium
    }
  })()

  const colorStyle = (() => {
    switch (type) {
      case 'light':
        return styles.button_blue_light
      case 'main':
        return styles.button_blue_main
      case 'dark':
        return styles.button_blue_dark
      case 'outlined':
        return styles.button_blue_outlined
      default:
        return styles.button_blue_main
    }
  })()

  const className = disabled ? `${sizeStyle} ${styles.button_grey_disabled}` : `${sizeStyle} ${colorStyle}`

  return (
    <button className={className} data-cy={`blue-button-${dataCy}`} disabled={disabled} onClick={onClick}>
      {startIconPath && (
        <>
          <img src={startIconPath} alt={label} />
          <Spacer size={4} axis={'horizontal'} />
        </>
      )}
      <span>{label}</span>
      {endIconPath && (
        <>
          <Spacer size={4} axis={'horizontal'} />
          <img src={endIconPath} alt={label} />
        </>
      )}
    </button>
  )
})

export default BlueButton
